//#region src/translations/es_DO.json
var es_DO_default = { "not-found": {} };
//#endregion
export { es_DO_default as default };

//# sourceMappingURL=es_DO.js.map